import { Breadcrumb, Modal, message, DatePicker, Row, Col, Button, Upload, Radio, Card, Input, Select, Checkbox, Typography, Form, Space } from 'antd';
import React, { useEffect, useState, } from 'react';
import styled from 'styled-components';
import { Navigate, Outlet, useNavigate, useLocation, useParams } from 'react-router-dom'
import { PlusOutlined, ExclamationCircleFilled, CloseOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useForm } from 'rc-field-form';
import PreviewImgModal from './components/Media/PreviewImgModal';
import axios from 'axios';
import './css/cramSchool.css';
const { Title, Paragraph, Text, Link } = Typography;
const { confirm } = Modal;
const InputOutline = styled.div`
    .ant-select-focused .ant-select-selector,
    .ant-select-selector:focus,
    .ant-select-selector:active,
    .ant-select-open .ant-select-selector {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
    }
    .ant-input{
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        border-radius:0px;
        background-color:#f5f5f5;
        border-width:2px
    }
    .ant-select-selector{
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        border-radius:0px;
        background-color:#f5f5f5;
    }
    .ant-input-status-error{
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        border-radius:0px;
        background-color:#f5f5f5;
        border-width:5px;
    }
`;
const StudentEnroll = () => {
    const [refreshToken, setRefreshToken] = useState('')
    const [refreshTokenStart, setRefreshTokenStart] = useState('')
    const [code, setCode] = useState(null);
    const navigate = useNavigate();
    const [other, setOther] = useState(false);
    const [relation, setRelation] = useState([])
    const [count, setCount] = useState(0);
    const [emergency_contact, set_emergency_contact] = useState([]);
    const { Id } = useParams();
    const [messageApi, contextHolder] = message.useMessage();
    const [grade_option, set_grade_option] = useState([]);
    const [modal_img, set_modal_img] = useState(false);
    const [open, setOpen] = useState(false);
    const [img, setImg] = useState('');
    const [fileList, setFileList] = useState([]);
    const [form_data, set_form_data] = useState([]);
    const [data, setData] = useState([{
        name: 'name',
        placeholder: '學生姓名（必填）',
        type: 'label',
        value: '',
        required: true,
    }, {
        name: 'name_english',
        placeholder: '學生英文姓名',
        type: 'input',
        value: '',
        required: false,
    }, {
        name: 'phone',
        placeholder: '學生手機號碼（必填）',
        type: 'input',
        value: '',
        required: true,
    }, {
        name: 'phone_home',
        placeholder: '學生家中電話（H）',
        type: 'input',
        value: '',
        required: false,
    }, {
        name: 'birthday',
        placeholder: '學生出生日期',
        type: 'datepicker',
        value: '',
        required: false,
    }, {
        name: 'email',
        placeholder: '就讀電子信箱（必填）',
        type: 'input',
        value: '',
        required: true,
    }, {
        name: 'line_id',
        placeholder: '學生 Line ID',
        type: 'input',
        value: '',
        required: false,
    }, {
        name: 'grade_id',
        placeholder: '請輸入學生當前年級（必填）',
        type: 'select',
        value: '',
        required: true,
    },
    //  {
    //     name: 'emergency_contact_name',
    //     placeholder: '請輸入緊急連絡人',
    //     type: 'input',
    //     value: '',
    //     required: false,
    // }, {
    //     name: 'emergency_contact_phone_number',
    //     placeholder: '請輸入緊急連絡人電話',
    //     type: 'input',
    //     value: '',
    //     required: false,
    // },
    {
        name: 'school',
        placeholder: '請輸入學校',
        type: 'input',
        value: '',
        required: false,
    }, {
        name: 'address',
        placeholder: '學生地址',
        type: 'input',
        value: '',
        required: false,
    },
        // {
        //     name: 'study_time_start',
        //     placeholder: '學生就學時間（起）',
        //     type: 'datepicker',
        //     value: '',
        //     required: false,
        // }, {
        //     name: 'study_time_end',
        //     placeholder: '學生就學時間（迄）',
        //     type: 'datepicker',
        //     value: '',
        //     required: false,
        // }
        , {
        name: 'note',
        placeholder: '備註',
        type: 'input',
        value: '',
        required: false,
    }])
    useEffect(() => {
        axios
            .get('/cramSchool/api/grade')
            .then((response) => {
                let data_tmp = [];
                // let data_json_tmp = {};
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['id']
                    data_json_tmp['label'] = value['name'];
                    data_tmp.push(data_json_tmp);
                })
                set_grade_option(data_tmp)
            })
        setOpen(true);
        get_relation();
        axios
            .get('/refresh_token', {})
            .then(response => {
                // console.log(response.data)
                setRefreshTokenStart(response.data)
            })
            .catch((error) => {
            })
            .finally(() => {
            })
        axios
            .get('/refresh_token', {})
            .then(response => {
                // console.log(response.data)
                setRefreshToken(response.data)
            })
            .catch((error) => {
            })
            .finally(() => {
            })
    }, [])
    const onSubmit = () => {
        if (form_data.name == undefined || form_data.phone == undefined || form_data.grade_id == undefined || form_data.email == undefined || form_data.name == '' || form_data.phone == '' || form_data.grade_id == '' || form_data.email == '') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '請完整填寫必填欄位',
            });
        } else {
            // console.log(form_data);
            let data_tmp = { ...form_data, refresh_token: refreshToken.refresh_token };
            data_tmp['emergency_contact'] = emergency_contact;
            data_tmp['file_id'] = fileList.map((item) => item.uid);
            axios
                .patch(`/cramSchool/api/student`, [data_tmp], {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('refresh_token')}`
                    }
                })
                .then((response) => {
                    if (response.data.status == 'failure') {
                        messageApi.open({
                            type: 'error',
                            content: '修改失敗',
                        });
                    } else {
                        localStorage.removeItem('refresh_token')
                        localStorage.removeItem('access_token')
                        messageApi.open({
                            type: 'success',
                            content: '修改成功',
                        });
                        setTimeout(() => {
                            navigate('/cramSchool');
                        }, [1000])
                    }
                })
        }
    };
    const handleChange = (name, value) => {
        set_form_data(pre => {
            return ({
                ...pre,
                [`${name}`]: value
            })
        })
    }
    const handleUpload = (e) => {
        e = e.file;
        let form_data = new FormData();
        form_data.append('inputFile', e);
        axios
            .post(`/cramSchool/api/file`, form_data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            .then((response) => {
                let file_id = parseInt(response.data.file_id);
                const dataurl = URL.createObjectURL(e);
                setFileList(
                    prev => {
                        return ([
                            ...prev,
                            {
                                uid: file_id,
                                url: dataurl
                            }
                        ])
                    }
                )
            })
    }
    const remove_emergency_contact = (i) => {
        set_emergency_contact(prev => prev.filter(filter_item => filter_item.key !== i));
    }
    const showDelete = (i) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                remove_emergency_contact(i)
            },
            centered: true
        });
    }
    const showConfirm = (e) => {
        confirm({
            title: '確認要刪除此張圖片嗎？',
            icon: <ExclamationCircleFilled />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                remove(e);
            },
        });
    };
    const handlePreview = (e) => {
        setImg(e.url);
        set_modal_img(true);
    }
    const remove = (e) => {
        setFileList(prev => prev.filter(filter_item => filter_item.uid !== e.uid));
    }
    const handleSubmit = (values) => {
        // console.log(values);
        axios
            .get('/cramSchool/api/verify_link', { params: { ...values, student_id: Id, code: code, refresh_token: refreshTokenStart.refresh_token } })
            .then((response) => {
                if (response.data.status == true) {
                    localStorage.setItem('refresh_token', response.data.refresh_token)
                    get_student();
                    setOpen(false);
                } else {
                    messageApi.open({
                        type: 'error',
                        content: '驗證失敗',
                    });
                }
            })
    }
    const get_student = () => {
        axios
            .get('/cramSchool/api/student', {
                params: { student_id: Id },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('refresh_token')}`
                }
            })
            .then((response) => {
                set_form_data(response.data?.data[0]);
                if (response.data?.data[0].emergency_contact != undefined && response.data?.data[0].emergency_contact.length != 0) {
                    let data_tmp = [];
                    response.data?.data[0].emergency_contact.map((item, i) => {
                        let data_json_tmp = {};
                        data_json_tmp['key'] = i;
                        data_json_tmp['id'] = item.emergency_contact_id;
                        data_json_tmp['emergency_contact_name'] = item.emergency_contact_name;
                        data_json_tmp['emergency_contact_phone_number'] = item.emergency_contact_phone_number;
                        data_json_tmp['relation_name'] = item.relation_name;
                        data_json_tmp['emergency_contact_line_id'] = item.emergency_contact_line_id;
                        data_json_tmp['emergency_contact_email'] = item.emergency_contact_email;
                        setCount(count + 1);
                        data_tmp.push(data_json_tmp);
                    })
                    set_emergency_contact(data_tmp)
                }
            })
    }
    useEffect(() => {
        console.log(form_data)
    }, [form_data])
    const get_relation = () => {
        axios
            .get('/cramSchool/api/relation')
            .then((response) => {
                let data_tmp = [];
                // let data_json_tmp = {};
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['relation_id']
                    data_json_tmp['label'] = value['name'];
                    data_tmp.push(data_json_tmp);
                })
                data_tmp.push({ label: '其他', value: null });
                setRelation(data_tmp)
            })
    }
    return (
        <>
            {contextHolder}
            <PreviewImgModal
                modal_img={modal_img}
                set_modal_img={set_modal_img}
                img={img}
            ></PreviewImgModal>
            <Modal
                style={{ pointerEvents: 'auto' }}
                open={open}
                // onCancel={e => { setOpen(false); }}
                footer={false}
                width={600}
                bodyStyle={{ backgroundColor: 'white' }}
                modalRender={(e) => <>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '15px',
                        borderRadius: '10px',
                        align: "space-between"
                    }}>
                        <Form
                            name="basic"
                            labelCol={{
                                span: 5,
                            }}
                            wrapperCol={{
                                span: 16,
                            }}
                            style={{
                                maxWidth: 600,
                            }}
                            initialValues={{
                                remember: true,
                            }}
                            onFinish={handleSubmit}
                            autoComplete="off"
                        >
                            <Form.Item
                                label="學號"
                                name="serial_name"
                                rules={[
                                    {
                                        required: true,
                                        message: '請輸入學號',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label="姓名"
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        message: '請輸入姓名',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Row justify="center" gutter={16} >
                                <Col >
                                    <img style={{ "height": "32px" }} class="input-group-addon" src={`${refreshTokenStart.code}`} id="code_pic" />
                                </Col>
                                <Col >
                                    <Form.Item
                                        name="code"
                                        rules={[
                                            {
                                                required: true,
                                                message: '請輸入驗證碼',
                                            },
                                        ]}
                                    >

                                        <Input
                                            onChange={(e) => setCode(e.target.value)}
                                            type="text"
                                            placeholder="驗證碼"
                                            autoComplete={"off"}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item
                                wrapperCol={{
                                    offset: 16,
                                    span: 8,
                                }}
                            >
                                <Space>
                                    <Button type="primary" htmlType="submit">
                                        驗證
                                    </Button>
                                    {/* <Button type="dashed" onClick={e => setOpen(false)}>
                                取消
                            </Button> */}
                                </Space>
                            </Form.Item>
                        </Form>
                    </div>
                </>}
            >
            </Modal>
            <InputOutline>
                <Col span={24} style={{ backgroundColor: '#f5f5f5', padding: '10px' }}>
                    <Row justify='center' style={{ paddingBottom: '10px' }}>
                        <div style={{ fontSize: '48px' }}>學生資料填寫</div>
                    </Row>
                    <Row gutter={[0, 8]} justify='center'>
                        <Col sm={{ span: 24 }} md={{ span: 20 }}  >
                            <Form
                                autoComplete="off"
                            >
                                <Row gutter={[8, 24]}>
                                    {grade_option && data.map((value, key) => {
                                        if (value.type == 'select') {
                                            return (
                                                <Col sm={{ span: 24 }} md={{ span: 12 }}  >
                                                    <Form.Item
                                                        // {...formItemLayout}
                                                        name={value.name}
                                                        label=""
                                                        rules={[
                                                            {
                                                                required: value.required == true ? true : false,
                                                                message: `請輸入${value.placeholder}`,
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            style={{
                                                                width: "100%",
                                                            }}
                                                            labelInValue
                                                            placeholder={value.placeholder}
                                                            value={form_data['grade_name'] || value.placeholder}
                                                            onChange={(value) => set_form_data(pre => {
                                                                return ({
                                                                    ...pre,
                                                                    'grade_id': value.value,
                                                                    'grade_name': value.label,
                                                                })
                                                            })}
                                                            options={grade_option}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            )
                                        } else if (value.type == 'datepicker') {
                                            return (
                                                <Col sm={{ span: 24 }} md={{ span: 12 }}  >
                                                    <Form.Item
                                                        // {...formItemLayout}
                                                        name={value.name}
                                                        label=""
                                                    // rules={[
                                                    //     {
                                                    //         required: true,
                                                    //         message: value.placeholder,
                                                    //     },
                                                    // ]}
                                                    >
                                                        <DatePicker style={{ width: '100%' }}
                                                            format={'YYYY-MM-DD'}
                                                            onChange={(_, dateString) => set_form_data(preState => {
                                                                return (
                                                                    {
                                                                        ...preState,
                                                                        [`${value.name}`]: dateString,
                                                                    }
                                                                )
                                                            })}
                                                            placeholder={value.placeholder} />
                                                    </Form.Item>

                                                </Col>
                                            )
                                        } else if (value.type == 'label') {
                                            return (
                                                <Col sm={{ span: 24 }} md={{ span: 12 }}  >
                                                    姓名：{form_data?.name}
                                                </Col>
                                            )
                                        } else {
                                            return (
                                                <Col sm={{ span: 24 }} md={{ span: 12 }}  >
                                                    <Form.Item
                                                        // {...formItemLayout}
                                                        name={value.name}
                                                        label=""
                                                        rules={[
                                                            {
                                                                required: value.required == true ? true : false,
                                                                message: `請輸入${value.placeholder}`,
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            placeholder={value.placeholder}
                                                            onChange={(e) => handleChange(value.name, e.target.value)}
                                                            value={form_data[`${value.name}`]}
                                                        />
                                                    </Form.Item>

                                                </Col>
                                            )
                                        }
                                    })}
                                    <Col sm={{ span: 24 }} md={{ span: 12 }} >
                                        <Upload
                                            accept="image/png,image/jpeg"
                                            customRequest={handleUpload}
                                            listType="picture-card"
                                            fileList={fileList}
                                            onPreview={handlePreview}
                                            onRemove={e => showConfirm(e)}
                                            // onChange={handleUpload} 
                                            beforeUpload={false}
                                            multiple
                                        >
                                            <div>
                                                <PlusOutlined />
                                                <div
                                                    style={{
                                                        marginTop: 8,
                                                    }}
                                                >
                                                    上傳學生照片
                                                </div>
                                            </div>
                                        </Upload>
                                    </Col>
                                    <Col span={24}>
                                        <Row gutter={[8, 8]}>
                                            {emergency_contact.map((item, i) => {
                                                // if (i != 0) {
                                                return (
                                                    <>
                                                        <Col span={12}>
                                                            <Card
                                                                size="small"
                                                                title={`緊急聯絡人 ${i + 1}`}
                                                                key={item.key}
                                                                extra={
                                                                    <CloseOutlined
                                                                        onClick={() => {
                                                                            showDelete(item.key)
                                                                        }}
                                                                    />
                                                                }
                                                            >
                                                                <Form.Item label="姓名" >
                                                                    <Input placeholder={'請輸入緊急連絡人'} type='text'
                                                                        value={item.emergency_contact_name}
                                                                        // name="emergency_contact"
                                                                        onChange={e =>
                                                                            set_emergency_contact(pre => {
                                                                                return (
                                                                                    pre.map((value) => {
                                                                                        if (value.key == item.key) {
                                                                                            return (
                                                                                                {
                                                                                                    ...value,
                                                                                                    emergency_contact_name: e.target.value
                                                                                                }
                                                                                            )
                                                                                        } else {
                                                                                            return ({ ...value })
                                                                                        }
                                                                                    })
                                                                                )
                                                                            })
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item label="電話" >
                                                                    <Input placeholder={'請輸入緊急連絡人電話'}
                                                                        type='text'
                                                                        value={item.emergency_contact_phone_number}
                                                                        // name="emergency_phone" 
                                                                        onChange={e =>
                                                                            set_emergency_contact(pre => {
                                                                                return (
                                                                                    pre.map((value) => {
                                                                                        if (value.key == item.key) {
                                                                                            return (
                                                                                                {
                                                                                                    ...value,
                                                                                                    emergency_contact_phone_number: e.target.value
                                                                                                }
                                                                                            )
                                                                                        } else {
                                                                                            return ({ ...value })

                                                                                        }
                                                                                    })
                                                                                )
                                                                            })
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item label="關係" >
                                                                    <Select placeholder={'請輸入與緊急連絡人的關係'}
                                                                        value={item.relation_name}
                                                                        // name="emergency_phone" 
                                                                        options={relation}
                                                                        labelInValue
                                                                        onChange={value => {
                                                                            if (value.value == null) {
                                                                                setOther(true);
                                                                            } else {
                                                                                setOther(false);
                                                                                set_emergency_contact(pre => {
                                                                                    return (
                                                                                        pre.map((values) => {
                                                                                            if (values.key == item.key) {
                                                                                                return (
                                                                                                    {
                                                                                                        ...values,
                                                                                                        relation_name: value['label']
                                                                                                    }
                                                                                                )
                                                                                            } else {
                                                                                                return ({ ...values })

                                                                                            }
                                                                                        })
                                                                                    )
                                                                                })
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                                {other &&
                                                                    <Form.Item label="填寫關係" >
                                                                        <Input placeholder={'請輸入與緊急連絡人的關係'}
                                                                            value={item.relation_name}
                                                                            // name="emergency_phone" 
                                                                            options={relation}
                                                                            labelInValue
                                                                            onChange={value => {
                                                                                set_emergency_contact(pre => {
                                                                                    return (
                                                                                        pre.map((values) => {
                                                                                            if (values.key == item.key) {
                                                                                                return (
                                                                                                    {
                                                                                                        ...values,
                                                                                                        relation_name: value['label']
                                                                                                    }
                                                                                                )
                                                                                            } else {
                                                                                                return ({ ...values })

                                                                                            }
                                                                                        })
                                                                                    )
                                                                                })
                                                                            }}
                                                                        />
                                                                    </Form.Item>
                                                                }
                                                                <Form.Item label="Line ID" >
                                                                    <Input placeholder={'請輸入與緊急連絡人的Line ID'}
                                                                        type='text'
                                                                        value={item.emergency_contact_line_id}
                                                                        // name="emergency_phone" 
                                                                        onChange={e =>
                                                                            set_emergency_contact(pre => {
                                                                                return (
                                                                                    pre.map((value) => {
                                                                                        if (value.key == item.key) {
                                                                                            return (
                                                                                                {
                                                                                                    ...value,
                                                                                                    emergency_contact_line_id: e.target.value
                                                                                                }
                                                                                            )
                                                                                        } else {
                                                                                            return ({ ...value })

                                                                                        }
                                                                                    })
                                                                                )
                                                                            })
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                                <Form.Item label="信箱" >
                                                                    <Input placeholder={'請輸入與緊急連絡人的信箱'}
                                                                        type='text'
                                                                        value={item.emergency_contact_email}
                                                                        // name="emergency_phone" 
                                                                        onChange={e =>
                                                                            set_emergency_contact(pre => {
                                                                                return (
                                                                                    pre.map((value) => {
                                                                                        if (value.key == item.key) {
                                                                                            return (
                                                                                                {
                                                                                                    ...value,
                                                                                                    emergency_contact_email: e.target.value
                                                                                                }
                                                                                            )
                                                                                        } else {
                                                                                            return ({ ...value })

                                                                                        }
                                                                                    })
                                                                                )
                                                                            })
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </Card>
                                                        </Col>
                                                    </>
                                                )

                                            })}
                                            <Col span={24}>
                                                <Button type='primary' onClick={e => { setCount(count + 1); emergency_contact.push({ key: count }) }} block>
                                                    + 新增緊急聯絡人、聯絡電話、關係
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Row justify="center" gutter={16} align={'top'} style={{ padding: '10px' }}>
                                            <Col >
                                                <img style={{ "height": "32px" }} class="input-group-addon" src={`${refreshToken.code}`} id="code_pic" />
                                            </Col>
                                            <Col >
                                                <Form.Item
                                                    name="code"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: '請輸入驗證碼',
                                                        },
                                                    ]}
                                                >

                                                    <Input
                                                        onChange={(e) => handleChange('code', e.target.value)}
                                                        type="text"
                                                        placeholder="驗證碼"
                                                        autoComplete={"off"}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col>
                                                <Button className='example' style={{ backgroundColor: '#566FB8' }} onClick={onSubmit} >
                                                    <div style={{ color: '#ffffff', fontSize: '14px' }}>
                                                        送出
                                                    </div>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row >
                </Col>
            </InputOutline >
        </>
    )
}
export default StudentEnroll;